<template>
    <v-layout justify-center>
        <v-dialog v-model="show" max-width="800px">
            <v-card>
                <v-card-title class="pa-0 ma-0">
                    <v-toolbar dark color="blue lighten-2" class="titlebar">
                        <v-btn icon dark @click="show = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>
                            {{botIndex == null && botId == null ? 'Создать нового бота' : 'Настройки бота'}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn text @click="createBot()" :disabled="!valid">{{buttonTitle}}</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                </v-card-title>
                <v-card-text class="content">
                    <v-container class="container-main mx-0 px-0" fluid>
                        <v-row>
                            <v-col cols="3" class="mx-0 px-0">
                                <v-list
                                        :dense="true"
                                        fixed
                                >
                                    <v-list-item-group v-model="selectedMenu" color="primary" mandatory>
                                        <v-list-item class="ma-0 px-1">
                                            <v-list-item-content class="my-0 py-1">
                                                <v-list-item-title>Настройки</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item class="ma-0 px-1">
                                            <v-list-item-content class="my-0 py-1">
                                                <v-list-item-title>Режим работы</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item class="ma-0 px-1" v-show="botModel.id !== null">
                                            <v-list-item-content class="my-0 py-1">
                                                <v-list-item-title>Подключение</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item class="ma-0 px-1" v-show="botModel.id !== null">
                                            <v-list-item-content class="my-0 py-1">
                                                <v-list-item-title>Модераторы</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item class="ma-0 px-1" v-show="botModel.id !== null">
                                            <v-list-item-content class="my-0 py-1">
                                                <v-list-item-title>Глобальные команды</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-col>
                            <v-col cols="9">
                                <v-form
                                        ref="form"
                                        v-model="valid"
                                >
                                    <bot-form-main :bot-model="botModel"  v-show="selectedMenu === 0" @save="createBot"></bot-form-main>
                                    <bot-form-work-schedule :botModel="botModel" :selectedMenu="selectedMenu" ></bot-form-work-schedule>
                                    <bot-form-connect-vk :bot-model="botModel"  v-show="selectedMenu === 2"></bot-form-connect-vk>
                                    <bot-form-moderator :botModel="botModel" :selectedMenu="selectedMenu" ></bot-form-moderator>
                                    <bot-form-commands :bot-model="botModel" :selectedMenu="selectedMenu" @updateCommands="updateCommands"></bot-form-commands>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
</template>
<script>

import BotFormMain from './BotFormMain'
import BotFormWorkSchedule from './BotFormWorkSchedule'
import BotFormConnectVk from './BotFormConnectVk'
import BotFormModerator from './BotFormModerator'
import BotFormCommands from './BotFormCommands'
import { mapGetters } from 'vuex'
export default {
    name: 'BotForm',
    components: {
        BotFormMain,
        BotFormWorkSchedule,
        BotFormConnectVk,
        BotFormModerator,
        BotFormCommands
    },
    data() {
        return {
            show: false,
            botModel: { id: null },
            selectedMenu: 0,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            valid: false
        }
    },
    props: ['visible', 'botIndex', 'botId'],
    methods: {
        createBot() {
            if (this.botModel.title.length > 50) {
                this.$dialog.notify.warning(`Имя бота не может превышать 28 символов`)
            } else {
                this.botModel.id = null
                if (this.botIndex != null) {
                    this.botModel.id = this.bots[this.botIndex].id
                } else if (this.botId != null) {
                    this.botModel.id = this.botId
                }
                this.$store.dispatch('bots/saveBot', this.botModel).then(result => {
                    if (result.ok) {
                        this.botModel.id = result.response.data.id
                        this.botModel.hash_id = result.response.data.hash_id
                        this.$emit('updateBotIndex', this.getBotIndex(result.response.data.id))
                        this.paramsSnackbar.color = 'success'
                        this.paramsSnackbar.text = result.response.text
                        this.snackbar = true
                    } else {
                        this.paramsSnackbar.color = 'error'
                        this.paramsSnackbar.text = result.response.text
                        this.snackbar = true
                    }
                })
            }
        },
        loadModel() {
            if ((this.botIndex === undefined || this.botIndex == null) && (this.botId === undefined || this.botId == null)) {
                this.botModel = Object.assign({}, this.botModelDef)
            } else {
                if (this.botId === undefined || this.botId == null) {
                    this.botModel = Object.assign({}, this.bots[this.botIndex])
                } else {
                    let index = this.getBotIndex(this.botId)
                    this.botModel = Object.assign({}, this.bots[index])
                }
            }
        },
        updateCommands(commands) {
            this.botModel.commands = commands.length === 0 ? null : JSON.stringify(commands)
        }
    },
    computed: {
        buttonTitle () { return this.botIndex != null || this.botId != null ? 'Сохранить' : 'Создать' },
        ...mapGetters({
            bots: 'bots/bots',
            getBotIndex: 'bots/getBotIndexById',
            botModelDef: 'bots/modelDefault'
        })
    },
    watch: {
        visible() {
            this.visible === true ? this.show = true : this.show = false
            if (this.visible) { this.loadModel() }
        },
        show() {
            if (this.show === false) {
                this.botModel = Object.assign({}, this.botModelDef)
                this.$refs.form.resetValidation()
                this.$emit('close')
            }
        }
    }
}
</script>

<style scoped>
    .container-main {
        width: 100vw;
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
    .content {
        flex-grow: 1;
        overflow-x: auto;
    }

</style>
